import { useMutation, useQuery } from "@tanstack/react-query"
import { mutationHandler } from "../mutationHandler"
import { ShareableLink } from "../../backend/types/shareableLink"

const generateShareableLink = (moneyflowId: string, name: string, img: File | null) => {
    const formData = new FormData()
    formData.append('name', name)
    if (img) {
        formData.append('img', img)
    }

    return fetch(`/api/moneyflow/${moneyflowId}/share`, {
        method: 'POST',
        body: formData,
    })
}

export const useGenerateShareableLinkMutation = (
    moneyflowId: string,
    img: File | null
) => useMutation({
    mutationFn: (name: string) =>
        mutationHandler<ShareableLink>(generateShareableLink(moneyflowId, name, img)),
})


export const useGetShareableLinkQuery = (linkId?: string) => useQuery<ShareableLink>({
    queryKey: [`moneyflow/link/${linkId}`],
    enabled: !!linkId
})
